import React, { useState } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    updateDoc,
    doc
} from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";

const cityStateData = [
    { phone_no: "6299269184", state: "Bihar", city: "Gaya" },
    { phone_no: "8409186303", state: "Bihar", city: "Gaya" },
    { phone_no: "7050142118", state: "Bihar", city: "Gaya" },
    { phone_no: "9279710321", state: "Bihar", city: "Gaya" },
    { phone_no: "7903564223", state: "Bihar", city: "Gaya" },
    { phone_no: "7320993188", state: "Bihar", city: "Gaya" },
    { phone_no: "9570826102", state: "Bihar", city: "Gaya" },
    { phone_no: "8709962667", state: "Bihar", city: "Gaya" },
    { phone_no: "9661409581", state: "Bihar", city: "Gaya" },
    { phone_no: "7970353774", state: "Bihar", city: "Gaya" },
    { phone_no: "8091702138", state: "Bihar", city: "Gaya" },
    { phone_no: "7463824093", state: "Bihar", city: "Gaya" },
    { phone_no: "7870302799", state: "Bihar", city: "Gaya" },
    { phone_no: "7463017164", state: "Bihar", city: "Gaya" },
    { phone_no: "6205061271", state: "Bihar", city: "Gaya" },
    { phone_no: "7277848248", state: "Bihar", city: "Gaya" },
    { phone_no: "7482855725", state: "Bihar", city: "Gaya" },
    { phone_no: "7667070835", state: "Bihar", city: "Gaya" },
    { phone_no: "9117436320", state: "Bihar", city: "Gaya" },
    { phone_no: "9798680893", state: "Bihar", city: "Gaya" },
    { phone_no: "6207191109", state: "Bihar", city: "Gaya" },
    { phone_no: "6204719981", state: "Bihar", city: "Gaya" },
    { phone_no: "7033955794", state: "Bihar", city: "Gaya" },
    { phone_no: "8809202600", state: "Bihar", city: "Gaya" },
    { phone_no: "7761046673", state: "Bihar", city: "Gaya" },
    { phone_no: "8340576011", state: "Bihar", city: "Gaya" },
    { phone_no: "8084258988", state: "Bihar", city: "Gaya" },
    { phone_no: "9006299858", state: "Bihar", city: "Gaya" },
    { phone_no: "6200436985", state: "Bihar", city: "Gaya" },
    { phone_no: "9102565133", state: "Bihar", city: "Gaya" },
    { phone_no: "8294910304", state: "Bihar", city: "Gaya" },
    { phone_no: "7739719002", state: "Bihar", city: "Gaya" },
    { phone_no: "8002016924", state: "Bihar", city: "Gaya" },
    { phone_no: "9122842954", state: "Bihar", city: "Gaya" },
    { phone_no: "7322034628", state: "Bihar", city: "Gaya" },
    { phone_no: "8100543721", state: "Bihar", city: "Gaya" },
    { phone_no: "9576921011", state: "Bihar", city: "Gaya" },
    { phone_no: "7070818001", state: "Bihar", city: "Gaya" },
    { phone_no: "7209888389", state: "Bihar", city: "Gaya" },
    { phone_no: "9128436869", state: "Bihar", city: "Gaya" },
    { phone_no: "9939533776", state: "Bihar", city: "Gaya" },
    { phone_no: "7543861512", state: "Bihar", city: "Gaya" },
    { phone_no: "9546953485", state: "Bihar", city: "Gaya" },
    { phone_no: "8292565626", state: "Bihar", city: "Gaya" },
    { phone_no: "7808093767", state: "Bihar", city: "Gaya" },
    { phone_no: "9973654133", state: "Bihar", city: "Gaya" },
    { phone_no: "7366931138", state: "Bihar", city: "Gaya" },
    { phone_no: "7050846607", state: "Bihar", city: "Gaya" },
    { phone_no: "9931289834", state: "Bihar", city: "Gaya" },
    { phone_no: "9162394657", state: "Bihar", city: "Gaya" },
    { phone_no: "7294968639", state: "Bihar", city: "Gaya" },
    { phone_no: "8002341596", state: "Bihar", city: "Gaya" },
    { phone_no: "8986377734", state: "Bihar", city: "Gaya" },
    { phone_no: "8284173340", state: "Bihar", city: "Gaya" },
    { phone_no: "9241715634", state: "Bihar", city: "Gaya" },
    { phone_no: "7484968528", state: "Bihar", city: "Gaya" },
    { phone_no: "8584890415", state: "Bihar", city: "Gaya" },
    { phone_no: "9973011676", state: "Bihar", city: "Gaya" },
    { phone_no: "7542014489", state: "Bihar", city: "Gaya" },
    { phone_no: "7564081359", state: "Bihar", city: "Gaya" },
    { phone_no: "9708772859", state: "Bihar", city: "Gaya" },
    { phone_no: "9525913937", state: "Bihar", city: "Gaya" },
    { phone_no: "9931441230", state: "Bihar", city: "Gaya" },
    { phone_no: "7870825746", state: "Bihar", city: "Gaya" },
    { phone_no: "9661928073", state: "Bihar", city: "Gaya" },
    { phone_no: "9430614829", state: "Bihar", city: "Gaya" },
    { phone_no: "8863886155", state: "Bihar", city: "Gaya" },
    { phone_no: "9279836826", state: "Bihar", city: "Gaya" },
    { phone_no: "9122880773", state: "Bihar", city: "Gaya" },
    { phone_no: "8063655812", state: "Bihar", city: "Gaya" },
    { phone_no: "9162048193", state: "Bihar", city: "Gaya" },
    { phone_no: "7562846981", state: "Bihar", city: "Gaya" },
    { phone_no: "8863857456", state: "Bihar", city: "Gaya" },
    { phone_no: "8210701556", state: "Bihar", city: "Gaya" },
    { phone_no: "9334872281", state: "Bihar", city: "Gaya" },
    { phone_no: "8987038556", state: "Bihar", city: "Gaya" },
    { phone_no: "7542963320", state: "Bihar", city: "Gaya" },
    { phone_no: "7050530283", state: "Bihar", city: "Gaya" },
    { phone_no: "7763975252", state: "Bihar", city: "Gaya" },
    { phone_no: "7783005953", state: "Bihar", city: "Gaya" },
    { phone_no: "9661826918", state: "Bihar", city: "Gaya" },
    { phone_no: "9373437052", state: "Bihar", city: "Gaya" },
    { phone_no: "6204234158", state: "Bihar", city: "Gaya" },
    { phone_no: "9570548096", state: "Bihar", city: "Gaya" },
    { phone_no: "7856876608", state: "Bihar", city: "Gaya" },
    { phone_no: "9852029028", state: "Bihar", city: "Gaya" },
    { phone_no: "6200957412", state: "Bihar", city: "Gaya" },
    { phone_no: "7261056842", state: "Bihar", city: "Gaya" },
    { phone_no: "8092801711", state: "Bihar", city: "Gaya" },
    { phone_no: "9801204610", state: "Bihar", city: "Gaya" },
    { phone_no: "7979847486", state: "Bihar", city: "Gaya" },
    { phone_no: "9896119783", state: "Bihar", city: "Gaya" },
    { phone_no: "8521317506", state: "Bihar", city: "Gaya" },
    { phone_no: "6287336430", state: "Bihar", city: "Gaya" },
    { phone_no: "7367038015", state: "Bihar", city: "Gaya" },
    { phone_no: "8539011948", state: "Bihar", city: "Gaya" },
    { phone_no: "8987110815", state: "Bihar", city: "Gaya" },
    { phone_no: "6201977814", state: "Bihar", city: "Gaya" },
    { phone_no: "9661217180", state: "Bihar", city: "Gaya" },
    { phone_no: "6203331978", state: "Bihar", city: "Gaya" },
    { phone_no: "8825385076", state: "Bihar", city: "Gaya" },
    { phone_no: "7739776696", state: "Bihar", city: "Gaya" },
    { phone_no: "8083477604", state: "Bihar", city: "Gaya" },
    { phone_no: "9162969826", state: "Bihar", city: "Gaya" },
    { phone_no: "7903868264", state: "Bihar", city: "Gaya" },
    { phone_no: "6265385293", state: "Bihar", city: "Gaya" },
    { phone_no: "9693040347", state: "Bihar", city: "Gaya" },
    { phone_no: "9523215665", state: "Bihar", city: "Gaya" },
    { phone_no: "7766800505", state: "Bihar", city: "Gaya" },
    { phone_no: "8160012494", state: "Bihar", city: "Gaya" },
    { phone_no: "7091651717", state: "Bihar", city: "Gaya" },
    { phone_no: "7463800924", state: "Bihar", city: "Gaya" },
    { phone_no: "9934035976", state: "Bihar", city: "Gaya" },
    { phone_no: "9102454229", state: "Bihar", city: "Gaya" },
    { phone_no: "7370953470", state: "Bihar", city: "Gaya" },
    { phone_no: "7366974691", state: "Bihar", city: "Gaya" },
    { phone_no: "7759946366", state: "Bihar", city: "Gaya" },
    { phone_no: "7781854614", state: "Bihar", city: "Gaya" },
    { phone_no: "7783898988", state: "Bihar", city: "Gaya" },
    { phone_no: "9006861570", state: "Bihar", city: "Gaya" },
    { phone_no: "9798323277", state: "Bihar", city: "Gaya" },
    { phone_no: "8002007131", state: "Bihar", city: "Gaya" },
    { phone_no: "8507889598", state: "Bihar", city: "Gaya" },
    { phone_no: "7870316579", state: "Bihar", city: "Gaya" },
    { phone_no: "9504648758", state: "Bihar", city: "Gaya" },
    { phone_no: "9097584711", state: "Bihar", city: "Gaya" },
    { phone_no: "9135027284", state: "Bihar", city: "Gaya" },
    { phone_no: "9798694446", state: "Bihar", city: "Gaya" },
    { phone_no: "9472664838", state: "Bihar", city: "Gaya" },
    { phone_no: "6204250539", state: "Bihar", city: "Gaya" },
    { phone_no: "7301496855", state: "Bihar", city: "Gaya" },
    { phone_no: "7766067161", state: "Bihar", city: "Gaya" },
    { phone_no: "8002526640", state: "Bihar", city: "Gaya" },
    { phone_no: "9939666972", state: "Bihar", city: "Gaya" },
    { phone_no: "6207555515", state: "Bihar", city: "Gaya" },
    { phone_no: "9939608104", state: "Bihar", city: "Gaya" },
    { phone_no: "9153125218", state: "Bihar", city: "Gaya" },
    { phone_no: "7362857006", state: "Bihar", city: "Gaya" },
    { phone_no: "7260959724", state: "Bihar", city: "Gaya" },
    { phone_no: "8797192674", state: "Bihar", city: "Gaya" },
    { phone_no: "9234181903", state: "Bihar", city: "Gaya" },
    { phone_no: "9661435034", state: "Bihar", city: "Gaya" },
    { phone_no: "6287371015", state: "Bihar", city: "Gaya" },
    { phone_no: "8294917782", state: "Bihar", city: "Gaya" },
    { phone_no: "9155781403", state: "Bihar", city: "Gaya" },
    { phone_no: "9523930723", state: "Bihar", city: "Gaya" },
    { phone_no: "8271149450", state: "Bihar", city: "Gaya" },
    { phone_no: "8084971266", state: "Bihar", city: "Gaya" },
    { phone_no: "7463975134", state: "Bihar", city: "Gaya" },
    { phone_no: "8434267221", state: "Bihar", city: "Gaya" },
    { phone_no: "7320993685", state: "Bihar", city: "Gaya" },
    { phone_no: "8102977326", state: "Bihar", city: "Gaya" },
    { phone_no: "6299658254", state: "Bihar", city: "Gaya" },
    { phone_no: "9576557691", state: "Bihar", city: "Gaya" },
    { phone_no: "6204661386", state: "Bihar", city: "Gaya" },
    { phone_no: "7296027356", state: "Bihar", city: "Gaya" },
    { phone_no: "9110902629", state: "Bihar", city: "Gaya" },
    { phone_no: "9693664423", state: "Bihar", city: "Gaya" },
    { phone_no: "9546064494", state: "Bihar", city: "Gaya" },
    { phone_no: "9006935778", state: "Bihar", city: "Gaya" },
    { phone_no: "8292515377", state: "Bihar", city: "Gaya" },
    { phone_no: "8292206933", state: "Bihar", city: "Gaya" },
    { phone_no: "9608151847", state: "Bihar", city: "Gaya" },
    { phone_no: "9031542170", state: "Bihar", city: "Gaya" },
    { phone_no: "6206612051", state: "Bihar", city: "Gaya" },
    { phone_no: "9162144061", state: "Bihar", city: "Gaya" },
    { phone_no: "9973203172", state: "Bihar", city: "Gaya" },
    { phone_no: "7485840280", state: "Bihar", city: "Gaya" },
    { phone_no: "6201267920", state: "Bihar", city: "Gaya" },
    { phone_no: "7739384744", state: "Bihar", city: "Gaya" },
    { phone_no: "9661271501", state: "Bihar", city: "Gaya" },
    { phone_no: "7033715594", state: "Bihar", city: "Gaya" },
    { phone_no: "7632883725", state: "Bihar", city: "Gaya" },
    { phone_no: "9798760054", state: "Bihar", city: "Gaya" },
    { phone_no: "9122728411", state: "Bihar", city: "Gaya" },
    { phone_no: "6203717470", state: "Bihar", city: "Gaya" },
    { phone_no: "9234746038", state: "Bihar", city: "Gaya" },
    { phone_no: "7209138468", state: "Bihar", city: "Gaya" },
    { phone_no: "8709558925", state: "Bihar", city: "Gaya" },
    { phone_no: "8092785932", state: "Bihar", city: "Gaya" },
    { phone_no: "9006897389", state: "Bihar", city: "Gaya" },
    { phone_no: "9060907898", state: "Bihar", city: "Gaya" },
    { phone_no: "7209121830", state: "Bihar", city: "Gaya" },
    { phone_no: "8804302684", state: "Bihar", city: "Gaya" },
    { phone_no: "9693630947", state: "Bihar", city: "Gaya" },
    { phone_no: "9304112878", state: "Bihar", city: "Gaya" },
    { phone_no: "8409729484", state: "Bihar", city: "Gaya" },
    { phone_no: "8210909499", state: "Bihar", city: "Gaya" },
    { phone_no: "8521042010", state: "Bihar", city: "Gaya" },
    { phone_no: "7644095880", state: "Bihar", city: "Gaya" },
    { phone_no: "7050665664", state: "Bihar", city: "Gaya" },
    { phone_no: "7541901416", state: "Bihar", city: "Gaya" },
    { phone_no: "9334805114", state: "Bihar", city: "Gaya" },
    { phone_no: "6200845477", state: "Bihar", city: "Gaya" },
    { phone_no: "7541902804", state: "Bihar", city: "Gaya" },
    { phone_no: "8766224973", state: "Bihar", city: "Gaya" },
    { phone_no: "7050636013", state: "Bihar", city: "Gaya" },
    { phone_no: "7970563936", state: "Bihar", city: "Gaya" },
    { phone_no: "9263794505", state: "Bihar", city: "Gaya" },
    { phone_no: "7004855911", state: "Bihar", city: "Gaya" },
    { phone_no: "6201982223", state: "Bihar", city: "Gaya" },
    { phone_no: "9102219993", state: "Bihar", city: "Gaya" },
    { phone_no: "9934549956", state: "Bihar", city: "Gaya" },
    { phone_no: "7654843427", state: "Bihar", city: "Gaya" },
    { phone_no: "6202449371", state: "Bihar", city: "Gaya" },
    { phone_no: "8102392610", state: "Bihar", city: "Gaya" },
    { phone_no: "8002130963", state: "Bihar", city: "Gaya" },
    { phone_no: "9142246136", state: "Bihar", city: "Gaya" },
    { phone_no: "7654632568", state: "Bihar", city: "Gaya" },
    { phone_no: "7491823266", state: "Bihar", city: "Gaya" },
    { phone_no: "8789911099", state: "Bihar", city: "Gaya" },
    { phone_no: "8507544607", state: "Bihar", city: "Gaya" },
    { phone_no: "7050403956", state: "Bihar", city: "Gaya" },
    { phone_no: "9852280356", state: "Bihar", city: "Gaya" },
    { phone_no: "9241265518", state: "Bihar", city: "Gaya" },
    { phone_no: "6201010077", state: "Bihar", city: "Gaya" },
    { phone_no: "6289673674", state: "Bihar", city: "Gaya" },
    { phone_no: "8210370927", state: "Bihar", city: "Gaya" },
    { phone_no: "6205499211", state: "Bihar", city: "Gaya" },
    { phone_no: "7004597590", state: "Bihar", city: "Gaya" },
    { phone_no: "9771562203", state: "Bihar", city: "Gaya" },
    { phone_no: "7256906083", state: "Bihar", city: "Gaya" },
    { phone_no: "8804983499", state: "Bihar", city: "Gaya" },
    { phone_no: "9263125775", state: "Bihar", city: "Gaya" },
    { phone_no: "7091998194", state: "Bihar", city: "Gaya" },
    { phone_no: "9135466109", state: "Bihar", city: "Gaya" },
    { phone_no: "8292461120", state: "Bihar", city: "Gaya" },
    { phone_no: "7367863909", state: "Bihar", city: "Gaya" },
    { phone_no: "8102655069", state: "Bihar", city: "Gaya" },
    { phone_no: "7493804850", state: "Bihar", city: "Gaya" },
    { phone_no: "8757271909", state: "Bihar", city: "Gaya" },
    { phone_no: "8083728727", state: "Bihar", city: "Gaya" },
    { phone_no: "9065562055", state: "Bihar", city: "Gaya" },
    { phone_no: "6201390421", state: "Bihar", city: "Gaya" },
    { phone_no: "6206162523", state: "Bihar", city: "Gaya" },
    { phone_no: "9065844302", state: "Bihar", city: "Gaya" },
    { phone_no: "9142248359", state: "Bihar", city: "Gaya" },
    { phone_no: "9065611781", state: "Bihar", city: "Gaya" },
    { phone_no: "9117019398", state: "Bihar", city: "Gaya" },
    { phone_no: "9229688660", state: "Bihar", city: "Gaya" },
    { phone_no: "9905052722", state: "Bihar", city: "Gaya" },
    { phone_no: "8709231629", state: "Bihar", city: "Gaya" },
    { phone_no: "7979090118", state: "Bihar", city: "Gaya" },
    { phone_no: "9102362193", state: "Bihar", city: "Gaya" },
    { phone_no: "9006650131", state: "Bihar", city: "Gaya" },
    { phone_no: "9110039928", state: "Bihar", city: "Gaya" },
    { phone_no: "7319753426", state: "Bihar", city: "Gaya" },
    { phone_no: "9716353654", state: "Bihar", city: "Gaya" },
    { phone_no: "6207542120", state: "Bihar", city: "Gaya" },
    { phone_no: "7634069124", state: "Bihar", city: "Gaya" },
    { phone_no: "9852249827", state: "Bihar", city: "Gaya" },
    { phone_no: "6206915839", state: "Bihar", city: "Gaya" },
    { phone_no: "9155580165", state: "Bihar", city: "Gaya" },
    { phone_no: "7667573688", state: "Bihar", city: "Gaya" },
    { phone_no: "7541069110", state: "Bihar", city: "Gaya" },
    { phone_no: "6205352342", state: "Bihar", city: "Gaya" },
    { phone_no: "7061478213", state: "Bihar", city: "Gaya" },
    { phone_no: "6206116303", state: "Bihar", city: "Gaya" },
    { phone_no: "7488362623", state: "Bihar", city: "Gaya" },
    { phone_no: "6299856895", state: "Bihar", city: "Gaya" },
    { phone_no: "9801140433", state: "Bihar", city: "Gaya" },
    { phone_no: "9693464594", state: "Bihar", city: "Gaya" },
    { phone_no: "7070111525", state: "Bihar", city: "Gaya" },
    { phone_no: "6207283554", state: "Bihar", city: "Gaya" },
    { phone_no: "9546092344", state: "Bihar", city: "Gaya" },
    { phone_no: "9931892783", state: "Bihar", city: "Gaya" },
    { phone_no: "6299390783", state: "Bihar", city: "Gaya" },
    { phone_no: "8825331226", state: "Bihar", city: "Gaya" },
    { phone_no: "6201943098", state: "Bihar", city: "Gaya" },
    { phone_no: "9263857015", state: "Bihar", city: "Gaya" },
    { phone_no: "9334740557", state: "Bihar", city: "Gaya" },
    { phone_no: "6205562212", state: "Bihar", city: "Gaya" },
    { phone_no: "7903590083", state: "Bihar", city: "Gaya" },
    { phone_no: "7857005135", state: "Bihar", city: "Gaya" },
    { phone_no: "6206980981", state: "Bihar", city: "Gaya" },
    { phone_no: "6202492823", state: "Bihar", city: "Gaya" },
    { phone_no: "8002000314", state: "Bihar", city: "Gaya" },
];

const UpdateParlourLocation = () => {
    const [running, setRunning] = useState(false);
    const [results, setResults] = useState([]);
    const [successCount, setSuccessCount] = useState(0);
    const [failCount, setFailCount] = useState(0);

    const handleUpdate = async () => {
        setRunning(true);
        let success = 0;
        let failed = 0;
        const updateResults = [];

        for (const entry of cityStateData) {
            const { phone_no, state, city } = entry;

            try {
                const q = query(
                    collection(db, "parlour_name"),
                    where("phone", "==", phone_no)
                );
                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    console.warn(`Phone not found: ${phone_no}`);
                    failed++;
                    updateResults.push({ phone: phone_no, status: "Not Found" });
                    continue;
                }

                const docRef = doc(db, "parlour_name", snapshot.docs[0].id);
                await updateDoc(docRef, { state, city });

                success++;
                updateResults.push({ phone: phone_no, status: "Updated" });
            } catch (err) {
                console.error(`Error updating ${phone_no}:`, err);
                failed++;
                updateResults.push({ phone: phone_no, status: "Error" });
            }
        }

        setSuccessCount(success);
        setFailCount(failed);
        setResults(updateResults);
        setRunning(false);

        Swal.fire("Update Complete ✅", `Updated: ${success}, Failed: ${failed}`, "success");
    };

    return (
        <div className="container p-4">
            <h4>🏢 Update Parlour City & State</h4>
            <p>Total Entries: {cityStateData.length}</p>

            <button
                className="btn btn-primary mb-3"
                onClick={handleUpdate}
                disabled={running}
            >
                {running ? "Updating..." : "🚀 Start Update"}
            </button>

            {(successCount + failCount > 0) && (
                <div className="mb-3">
                    <strong>✅ Updated:</strong> {successCount} |
                    <strong className="text-danger ms-2">❌ Failed:</strong> {failCount}
                </div>
            )}

            {results.length > 0 && (
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Phone</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map((row, idx) => (
                            <tr key={idx}>
                                <td>{row.phone}</td>
                                <td
                                    className={
                                        row.status === "Updated"
                                            ? "text-success"
                                            : row.status === "Not Found"
                                                ? "text-warning"
                                                : "text-danger"
                                    }
                                >
                                    {row.status}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default UpdateParlourLocation;
